import * as types from './actionTypes';

export function setChartDataType(val) {
  return {type: types.SET_CHART_DATA_TYPE, setToVal: val};
}
